import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import Layout from '@/layout/index.vue';
import logo from '@/assets/logo.png';

const routes: RouteRecordRaw[] = [
  {
    path: '/dataview/data-space',
    component: () => import('@/views/DataView/DataSpace/index.vue'),
    name: 'DataViewDataSpace',
    meta: {
      title: '数据空间驾驶舱大屏',
      fixNav: true,
    },
  },
  {
    path: '/dataview/data-foundation',
    component: () => import('@/views/DataView/DataFoundation/index.vue'),
    name: 'DataViewDataFoundation',
    meta: {
      title: '宁波市城市数据底座',
      fixNav: true,
    },
  },
  {
    path: '/dataview/sksj',
    component: () => import('@/views/DataView/SKSJ/index.vue'),
    name: 'DataViewDataSKSJ',
    meta: {
      title: '时空数据服务专区驾驶舱大屏',
      fixNav: true,
    },
  },
  {
    path: '/login',
    component: () => import('@/views/Login/index.vue'),
    name: 'Login',
    meta: {
      title: '登录',
      fixNav: true,
    },
  },
  {
    path: '/register',
    component: () => import('@/views/Register/index.vue'),
    name: 'register',
    meta: {
      title: '注册',
      fixNav: true,
    },
  },
  {
    path: '/invitation',
    component: () => import('@/views/Invitation/index.vue'),
    name: 'ZoneInviteUser',
    meta: {
      title: '专区邀请用户加入企业',
      fixNav: true,
    },
  },
  {
    path: '/loginByLinkUUID',
    component: () => import('@/views/Login/loginByLinkUUID.vue'),
    name: 'LoginByLinkUUID',
    meta: {
      title: '通过ct登录',
      fixNav: true,
    },
  },
  {
    path: '/loginByToken',
    component: () => import('@/views/Login/loginByToken.vue'),
    name: 'LoginByToken',
    meta: {
      title: '通过token登录',
      fixNav: true,
    },
  },
  {
    // H5 活动填报页（微信小程序 webview 中打开），token 和活动 id 从 url 参数获取
    path: '/h5/news/fill',
    component: () => import('@/views/News/FillFormH5/index.vue'),
    name: 'FillFormH5',
    meta: {
      title: '活动填报',
      fixNav: true,
    },
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        component: () => import('@/views/Home/index.vue'),
        name: 'Home',
        meta: {
          title: '宁波城市可信数据空间',
          Image: logo,
          fixNav: true,
        },
      },
      {
        path: '/trade-center',
        component: () => import('@/views/Trade/index.vue'),
        name: 'Trade',
        meta: {
          title: '流通专区',
          hideMenu: true,
        },
      },
      {
        path: '/search',
        component: () => import('@/views/Home/Search.vue'),
        name: 'search',
        meta: {
          title: '搜索结果',
          active: '/home',
        },
      },
      {
        path: '/share',
        component: () => import('@/views/Share/index.vue'),
        name: 'Share',
        meta: {
          title: '分享',
          active: '/home',
        },
      },
      {
        path: '/market',
        component: () => import('@/views/Market/index.vue'),
        name: 'Market',
        meta: {
          title: '全量资源市场',
          hideMenu: true,
        },
      },
      {
        path: '/market/:id',
        component: () => import('@/views/Market/detail.vue'),
        name: 'MarketDetail',
        meta: {
          title: '数据产品详情',
          history: [
            { name: 'CloudMarketHome', title: '全量资源', disabled: true },
            { name: 'MarketDetail', title: '数据产品详情' },
          ],
          active: '/market',
        },
      },
      {
        path: '/doc-center/:bizId',
        component: () => import('@/views/Market/doc-center.vue'),
        name: 'DocumentCenter',
        meta: {
          title: '文档中心',
          fixNav: true,
          history: [{ name: 'DocumentCenter', title: '文档中心' }],
        },
      },
      {
        path: '/requirement-hall',
        component: () => import('@/views/Market/Requirements/index.vue'),
        name: 'RequirementHall',
        meta: {
          title: '需求大厅',
          active: '/cloud-market/home',
          fixNav: true,
          history: [
            { name: 'CloudMarketHome', title: '甬数云市 · 首页' },
            { name: 'RequirementHall', title: '需求大厅' },
          ],
        },
      },
      {
        path: '/requirement-publish',
        component: () => import('@/views/Market/Requirements/publish.vue'),
        name: 'RequirementPublish',
        meta: {
          title: '需求详情页',
          active: '/cloud-market/home',
          fixNav: true,
          history: [
            { name: 'CloudMarketHome', title: '甬数云市 · 首页' },
            { name: 'RequirementHall', title: '需求大厅' },
            { name: 'RequirementPublish', title: '需求详情页' },
          ],
        },
      },
      {
        path: '/requirement-detail/:demandId',
        component: () => import('@/views/Market/Requirements/detail.vue'),
        name: 'RequirementDetail',
        meta: {
          title: '需求详情',
          active: '/market',
          history: [
            { name: 'RequirementHall', title: '需求大厅' },
            { name: 'RequirementDetail', title: '需求大厅详情' },
          ],
          fixNav: true,
        },
      },
      {
        path: '/data-company',
        component: () => import('@/views/DataCompany/index.vue'),
        name: 'DataCompany',
        meta: {
          title: '数商资源中心',
          hideMenu: true,
        },
      },
      {
        path: '/data-company/:id',
        component: () => import('@/views/DataCompany/detail.vue'),
        name: 'DataCompanyDetail',
        meta: {
          title: '数商详情',
          active: '/data-company',
        },
      },
      {
        path: '/ecological-build',
        component: () => import('@/views/EcologicalBuild/index.vue'),
        name: 'EcologicalBuild',
        meta: {
          title: '生态共建',
          active: '/data-company',
        },
      },
      {
        path: '/news',
        component: () => import('@/views/News/index.vue'),
        name: 'News',
        meta: {
          title: '新闻资讯',
          fixNav: true,
        },
      },
      {
        path: '/nb-data-dynamics/list',
        component: () => import('@/views/NBDataDynamics/index.vue'),
        name: 'NewsDynamics',
        meta: {
          title: '甬数动态',
          active: '/home',
          history: [{ name: 'NewsDynamics', title: '甬数动态' }],
          fixNav: true,
        },
      },
      //   {
      //     path: '/news/:type',
      //     component: () => import('@/views/News/list.vue'),
      //     name: 'NewsList',
      //     meta: {
      //       title: '新闻资讯',
      //       active: '/news',
      //     },
      //   },
      {
        path: '/news/activity/:id',
        component: () => import('@/views/News/ActivityDetail/index.vue'),
        name: 'ActivityDetail',
        meta: {
          title: '活动详情',
          active: '/news',
          history: [{ name: 'ActivityDetail', title: '活动详情' }],
          fixNav: true,
        },
      },
      {
        path: '/news/fill/:id',
        component: () => import('@/views/News/FillForm/index.vue'),
        name: 'FillForm',
        meta: {
          title: '活动填表',
          active: '/news',
          history: [
            { name: 'ActivityDetail', title: '活动详情' },
            { name: 'FillForm', title: '活动填表' },
          ],
          fixNav: true,
        },
      },
      {
        path: '/news/:type/:id',
        component: () => import('@/views/News/detail.vue'),
        name: 'NewsDetail',
        meta: {
          title: '甬数动态详情',
          active: '/nb-data-dynamics/list',
          fixNav: true,
        },
      },
      {
        path: '/directory-search',
        component: () => import('@/views/DirectorySearch/Index.vue'),
        name: 'DirectorySearch',
        meta: {
          title: '全量目录检索',
          fixNav: true,
        },
      },
      {
        path: '/directory-search-main',
        component: () => import('@/views/DirectorySearchMain/Index.vue'),
        name: 'DirectorySearchMain',
        meta: {
          title: '全量目录检索',
          fixNav: true,
          active: '/directory-search',
        },
      },
      {
        path: '/eco-collab',
        component: () => import('@/views/EcoCollab/Index.vue'),
        name: 'EcoCollab',
        meta: {
          title: '生态合作',
          fixNav: true,
        },
      },

      // ------------------规则指南路由------------------
      {
        path: '/rules',
        component: () => import('@/views/Rules/index.vue'),
        name: 'Rules',
        meta: {
          title: '规则指南',
          fixNav: true,
        },
      },
      {
        path: '/rules/space-guide-list',
        component: () => import('@/views/Rules/space-guide-list.vue'),
        name: 'SpaceGuideList',
        meta: {
          title: '空间指南列表页',
          fixNav: true,
          history: [{ name: 'SpaceGuideList', title: '空间指南' }],
        },
      },
      {
        path: '/rules/rule-consensus-list',
        component: () => import('@/views/Rules/rule-consensus-list.vue'),
        name: 'RuleConsensusList',
        meta: {
          title: '规则共识列表页',
          fixNav: true,
          history: [{ name: 'RulesConsensusList', title: '规则共识' }],
        },
      },
      {
        path: '/rules/space-guide/:id',
        component: () => import('@/views/Rules/space-guide-details.vue'),
        name: 'SpaceGuideDetails',
        meta: {
          title: '空间指南详情',
          fixNav: true,
          history: [{ name: 'SpaceGuideDetails', title: '指南详情' }],
        },
      },
      // ------------------规则指南路由------------------

      {
        path: '/about-us',
        component: () => import('@/views/AboutUs/index.vue'),
        name: 'AboutUs',
        meta: {
          title: '关于我们',
          fixNav: true,
        },
      },
      {
        path: '/form/scgcxy',
        component: () => import('@/views/Form/Scgcxy.vue'),
        name: 'form_scgcxy',
        meta: {
          title: '数创港创新园申报表',
          fixNav: true,
        },
      },
      {
        path: '/form/sjqypxk',
        component: () => import('@/views/Form/Sjqypxk.vue'),
        name: 'form_sjqypxk',
        meta: {
          title: '数据企业（数商）培育库征集表',
          fixNav: true,
        },
      },
      {
        path: '/cart',
        component: () => import('@/views/Cart/index.vue'),
        name: 'Cart',
        meta: {
          title: '购物车',
          history: [{ name: 'Cart', title: '购物车' }],
          fixNav: true,
        },
      },
      {
        path: '/scene/:id',
        component: () => import('@/views/Scene/index.vue'),
        name: 'SceneDetail',
        meta: {
          title: '应用场景详情页',
          history: [
            { name: 'DirectorySearchMain', title: '全量目录检索' },
            { name: 'Scene', title: '应用场景详情页' },
          ],
          fixNav: true,
        },
      },
      // ── 甬数云市 ──
      {
        path: '/cloud-market/home',
        component: () => import('@/views/CloudMarket/Home/index.vue'),
        name: 'CloudMarketHome',
        meta: {
          title: '甬数云市 · 首页',
          active: '/cloud-market/home',
          fixNav: true,
        },
      },
      {
        path: '/cloud-market/zone',
        component: () => import('@/views/CloudMarket/Zone/index.vue'),
        name: 'CloudMarketZone',
        meta: {
          title: '甬数云市 · 专区',
          active: '/cloud-market/zone',
          fixNav: true,
        },
      },
      {
        path: '/cloud-market/zone/details/home/:id',
        component: () =>
          import('@/views/CloudMarket/ZoneDetailsHome/index.vue'),
        name: 'CloudMarketZoneDetailsHome',
        meta: {
          title: '专区详情首页',
          active: '/cloud-market/zone',
          fixNav: true,
        },
      },
      {
        path: '/cloud-market/zone/details/:id',
        component: () => import('@/views/CloudMarket/ZoneDetails/index.vue'),
        name: 'CloudMarketZoneDetails',
        meta: {
          title: '专区详情',
          active: '/cloud-market/zone',
          history: [
            { name: 'CloudMarketZone', title: '甬数云市 · 专区' },
            { name: 'CloudMarketZoneDetails', title: '专区详情' },
          ],
          fixNav: true,
        },
      },
      {
        path: '/cloud-market/enterprise',
        component: () => import('@/views/CloudMarket/Enterprise/index.vue'),
        name: 'CloudMarketEnterprise',
        meta: {
          title: '甬数云市 · 企业',
          active: '/cloud-market/enterprise',
          fixNav: true,
        },
      },
      {
        path: '/cloud-market/enterprise/details/home/:id',
        component: () =>
          import('@/views/CloudMarket/EnterpriseDetailsHome/index.vue'),
        name: 'CloudMarketEnterpriseDetailsHome',
        meta: {
          title: '企业详情首页',
          active: '/cloud-market/enterprise',
          fixNav: true,
        },
      },
      {
        path: '/cloud-market/enterprise/details/:id',
        component: () =>
          import('@/views/CloudMarket/EnterpriseDetails/index.vue'),
        name: 'CloudMarketEnterpriseDetails',
        meta: {
          title: '企业数据详情',
          active: '/cloud-market/enterprise',
          history: [
            { name: 'CloudMarketEnterprise', title: '甬数云市 · 企业' },
            {
              name: 'CloudMarketEnterpriseDetailsHome',
              title: '企业 · 数商',
            },
            { name: 'CloudMarketEnterpriseDetails', title: '数据详情' },
          ],
          fixNav: true,
        },
      },
      {
        path: '/cloud-market/workshop',
        component: () => import('@/views/CloudMarket/Workshop/index.vue'),
        name: 'CloudMarketWorkshop',
        meta: {
          title: '甬数云市 · 工坊',
          active: '/cloud-market/workshop',
          fixNav: true,
        },
      },
      {
        path: '/cloud-market/workshop/details',
        component: () =>
          import('@/views/CloudMarket/WorkshopDetails/index.vue'),
        name: 'CloudMarketWorkshopDetails',
        meta: {
          title: '工坊数据详情',
          active: '/cloud-market/workshop',
          history: [
            { name: 'CloudMarketWorkshop', title: '工坊首页' },
            { name: 'CloudMarketWorkshopDetails', title: '工坊详情' },
          ],
          fixNav: true,
        },
      },
      {
        path: '/cloud-market/contact',
        component: () => import('@/views/CloudMarket/Contact/index.vue'),
        name: 'CloudMarketContact',
        meta: {
          title: '合作联系',
          active: '/cloud-market/home',
          fixNav: true,
        },
      },

      // 公共数据利用
      {
        path: '/common-data',
        component: () => import('@/views/CommonData/index.vue'),
        name: 'CommonData',
        meta: {
          title: '公共数据利用',
          fixNav: true,
        },
      },

      // 数据跨域流通
      {
        path: '/data-mobility',
        component: () => import('@/views/DataMobility/index.vue'),
        name: 'DataMobility',
        meta: {
          title: '数据跨域流通',
          fixNav: true,
        },
      },

      // 数据跨域流通 详情
      {
        path: '/data-mobility/detail/:id',
        component: () => import('@/views/DataMobility/detail.vue'),
        name: 'DataMobilityDetail',
        meta: {
          title: '数据跨域流通详情',
          fixNav: true,
          history: [
            { name: 'DataMobility', title: '数据跨域流通' },
            { name: 'DataMobilityDetail', title: '标识解析' },
          ],
        },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/404.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  // 添加滚动行为配置
  scrollBehavior(to, _from, savedPosition) {
    // 如果有保存的位置（浏览器前进/后退），恢复到该位置
    if (savedPosition) {
      return savedPosition;
    }
    // 如果有锚点，滚动到锚点位置
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 0, // 固定导航栏高度偏移
      };
    }
    // 默认滚动到顶部
    return { top: 0 };
  },
});

// router.beforeEach(async (to: any) => {
//   if (to.meta.title) {
//     // 判断是否有标题
//     // document.title = to.meta.title;
//   }
// });

// ───────────── 手动维护路由历史栈 ─────────────
// vue-router 没有提供"是否可回退"的判断 API，直接打开页面时 router.back() 不会跳转，
// 这里手动记录应用内的访问历史，供面包屑"返回"按钮等场景判断是否显示/可回退。

export interface RouteHistoryItem {
  /** vue-router 在 history.state 中维护的位置值 */
  position: number;
  /** 路由完整路径（含 query） */
  fullPath: string;
  /** 路由 name */
  name?: string | symbol | null;
  /** 页面标题 */
  title: string;
}

const routeHistoryStack: RouteHistoryItem[] = [];
let lastHistoryPosition = -1;

/** 获取当前路由历史栈副本 */
export function getRouteHistoryStack(): RouteHistoryItem[] {
  return [...routeHistoryStack];
}

/** 判断是否可回退（栈内记录数 >= 2 时 router.back() 才有可回退的路由） */
export function canGoBack(): boolean {
  return routeHistoryStack.length > 1;
}

router.afterEach((to) => {
  const position: number =
    window.history.state?.position ?? lastHistoryPosition + 1;

  if (position < lastHistoryPosition) {
    // 浏览器"后退"：弹出被回退掉的记录，保持与浏览器历史一致
    while (
      routeHistoryStack.length &&
      routeHistoryStack[routeHistoryStack.length - 1].position >= position
    ) {
      routeHistoryStack.pop();
    }
  } else if (position === lastHistoryPosition && routeHistoryStack.length) {
    // 同位置导航（replace / 重定向）：覆盖栈顶记录
    routeHistoryStack.pop();
  }

  routeHistoryStack.push({
    position,
    fullPath: to.fullPath,
    name: to.name,
    title: (to.meta.title as string) ?? '',
  });

  lastHistoryPosition = position;
});

export default router;
